<template>
  <div class="schedule" style="margin-left: 10px;">
    <div class="shadow">
      <div class="schedule-header">
        <div class="schedule-title">赛程</div>
        <div class="schedule-swiper">
          <div @click="slidePrev" class="prev-button control-button"
               :class="{'disabled-button': activeIndex === 0}"></div>
          <div class="swiper">
            <swiper :options="swiperOption" ref="scheduleSwiper">
              <swiper-slide v-for="(slide, i) in roundList" :key="i" :class="{'selected-slide': i === 0}">{{ slide }}
              </swiper-slide>
            </swiper>
          </div>
          <div @click="slideNext" class="next-button control-button"
               :class="{'disabled-button': activeIndex === roundList.length - 5}"></div>
        </div>
      </div>
      <div class="divider"></div>
      <div class="schedule-list" id="scheduleListY">
        <template v-for="(match, index) in scheduleList[roundIndex]">
          <div class="match" >
            <div class="match-date">
              <div class="time">{{ match.time }}</div>
              <div class="date">{{ match.date }}</div>
            </div>
            <div class="divider-column"></div>
            <div class="team-info">
              <div class="team-name" style="text-align: right;"
                   :style="{'fontSize': match.teamA_name === '白鲨.斗鱼' ? '22px' : (match.teamA_name === 'XROCK.斗鱼'||match.teamA_name === 'eStar.斗鱼'||match.teamA_name === 'EDG.斗鱼') ? '24px' : '24px'}">
                {{ match.teamA_name }}
              </div>
              <img class="team-icon" :src="'/static/img/team_logo/'+match.teamA_name+'.png'" :alt="match.teamA_name">
              <!--            <img class="team-icon" :src="match.imgA" :alt="match.teamA_name" />-->
              <div class="team-score">
                <div class="win-count" :class="{'win': match.winner === 'A'}">{{ match.scoreA }}</div>
                <div class="colon">:</div>
                <div class="win-count" :class="{'win': match.winner === 'B'}">{{ match.scoreB }}</div>
              </div>
              <!--            <img class="team-icon" :src="match.imgB" :alt="match.teamB_name" />-->
              <img class="team-icon" :src="'/static/img/team_logo/'+match.teamB_name+'.png'" :alt="match.teamB_name">
              <div class="team-name" style="text-align: left;"
                   :style="{'fontSize': match.teamB_name === '白鲨.斗鱼' ? '22px' : (match.teamB_name === 'XROCK.斗鱼' ||match.teamB_name === 'eStar.斗鱼' ||match.teamB_name === 'EDG.斗鱼' )? '24px' : '24px'}">
                {{ match.teamB_name }}
              </div>
            </div>
            <div class="match-info">
              <div style="cursor: pointer" v-if="match.game_id" @click="routerToWarReportC(match.game_id,index)">数据
              </div>
<!--                            <div style="cursor: pointer">数据</div>-->
            </div>
          </div>
          <div class="divider"></div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
const log = console.log.bind(console)
// swiper 的方法中, this 指向 swiper 实例
// created 时, 把 vue 实例赋值给 that
let that = null
import {swiper, swiperSlide} from 'vue-awesome-swiper'

export default {
  name: "Schedule",
  components: {
    swiper,
    swiperSlide,
  },
  props: {
    roundList: Array,
    scheduleList: Array,
    active: Number
  },
  data() {
    return {
      activeIndex: 0,
      roundIndex: 0,
      swiperOption: {
        // autoplay: 3500,
        slidesPerView: 'auto',
        // spaceBetween: 10,
        setWrapperSize: true,
        paginationClickable: true,
        mousewheelControl: true,
        observeParents: true,
        grabCursor: true,
        startTime: null,
        onTap(swiper) {
          that.toggleClass(swiper)
        },
        onSlideChangeEnd(swiper) {
          that.activeIndex = swiper.activeIndex
        }
      },
    }
  },
  created() {
    // 把 vue 实例赋值给 that 供 swiper 中的方法使用
    that = this
    this.startTime = this.getNowDate() + ' ' + '00:00:00'  //结果： 当前日期0点
    // this.startTime = '2022-08-30 00:00:00'  //结果： 当前日期0点
    this.startTime = parseInt(new Date(this.startTime).getTime()) + '';
  },
  computed: {
    swiper() {
      return this.$refs.scheduleSwiper.swiper
      // console.log(123)
    },
  },

  mounted() {
    this.getScrollTop()
  },
  watch: {
    active(val) {
      this.$nextTick(() => {
        this.activeIndex = val

        this.swiper.slideTo(val)
        // 所有 slide dom
        let slides = this.swiper.slides
        console.log(slides);
        // 当前点击的 index
        let clickedIndex = val
        this.roundIndex = val
        // swiper-slide 标签使用 :class 无法动态绑定 class, 这里手动移除添加 class
        Object.entries(slides).forEach((v, i) => {
          let slide = v[1]
          if (slide.classList) {
            if (slide.classList.contains('selected-slide') && i !== clickedIndex) {
              slide.classList.remove('selected-slide')
            } else if (i === clickedIndex) {
              slide.classList.add('selected-slide')
            }
          }
        })
      })
    }
  },
  methods: {
    toggleClass: function (swiper) {
      // 所有 slide dom
      let slides = swiper.slides
      // 当前点击的 index
      let clickedIndex = swiper.clickedIndex
      this.roundIndex = clickedIndex
      // swiper-slide 标签使用 :class 无法动态绑定 class, 这里手动移除添加 class
      Object.entries(slides).forEach((v, i) => {
        let slide = v[1]
        if (slide.classList) {
          if (slide.classList.contains('selected-slide') && i !== clickedIndex) {
            slide.classList.remove('selected-slide')
          } else if (i === clickedIndex) {
            slide.classList.add('selected-slide')
          }
        }
      })
    },
    slidePrev() {
      console.log(this.activeIndex);
      if (this.activeIndex !== 0) {
        this.swiper.slidePrev()
      }
    },
    slideNext() {
      console.log(this.activeIndex);
      if (this.activeIndex !== this.roundList.length - 5 && this.roundList.length > 0) {
        this.swiper.slideNext()
      }
    },
    routerToWarReportC(gameId, index) {
      this.$parent.routerToWarReport(gameId, index, this.roundIndex)
    },

    getScrollTop(){
      // console.log(123)
      setTimeout(()=>{
        let scheduleListY = document.getElementById('scheduleListY')
        let scrollNum = 0;
        this.scheduleList[this.roundIndex].forEach((match, index)=>{
          let time = parseInt(new Date(match.date).getTime()) + '';
          // console.log(time)
          // console.log(this.startTime)
          if(this.startTime > time){
            scrollNum++;
          }
        })
        console.log(scrollNum)
        scheduleListY.scrollTop = scrollNum * 100;
      }, 1000)
    },

    /**
     * 查询当天日期
     */
    getNowDate() {
      const timeOne = new Date()
      const year = timeOne.getFullYear()
      let month = timeOne.getMonth() + 1
      let day = timeOne.getDate()
      month = month < 10 ? '0' + month : month
      day = day < 10 ? '0' + day : day
      const NOW_MONTHS_AGO = `${year}-${month}-${day}`
      return NOW_MONTHS_AGO
    }

  }
}
</script>

<style scoped>
.schedule {
  position: relative;
  width: 740px;
  height: 680px;
  margin-left: 12px;
  box-sizing: border-box;
  background: rgba(0, 0, 0, 0.2);
  border: 1px solid #fabf8b;
  color: #FFFFFF;
  background-image: url("~@/assets/images/2024CFPLPC.png");
  background-size: cover;
  background-position: -422px 0;
  overflow-y: auto;
}

.shadow {
  /*position: absolute;*/
  /*top: 0;*/
  /*left: 0;*/
  /*width: 690px;*/
  /*!*height: 700px;*!*/
  /*background: rgba(0, 0, 0, .5)*/
}

.schedule::before {
  content: "";
  background-image: url("../../../../../assets/images/triangle.svg");
  position: absolute;
  left: 3px;
  top: 3px;
  width: 12px;
  height: 12px;
  z-index: 8;
}

.schedule-header {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  height: 89px;
  background: rgba(0, 0, 0, 0.3);
  /*background: red;*/
}

.schedule-title {
  font-size: 18px;
  font-weight: bold;
}

.schedule-list-overflow {
  overflow-y: auto;
  height: 587px;
}

.schedule-list-overflow::-webkit-scrollbar {
  display: none; /* Chrome, Safari, and Opera */
}

.schedule-list {
  height: 575px;
  overflow-x: hidden;
  overflow-y: auto;
}


.schedule-swiper {
  display: flex;
  justify-content: space-evenly;
  /*justify-content:center;*/
  align-items: center;
}

.swiper {
  /*width: 600px;*/
  width: 560px;
  overflow: hidden;
  /*display: flex;*/
  /*!*justify-content: space-evenly;*!*/
  /*justify-content:center;*/
  /*align-items: center;*/
}

.swiper-slide {
  width: 100px !important;
  height: 34px;
  line-height: 34px;
  background: rgba(0, 0, 0, 0.05);
  border: 1px solid #fabf8b;
  margin-right: 10px;
}

.selected-slide {
  /*background: #fabf8b;*/
  background: url("../../../../../assets/images/selected_slide.png");
}

.control-button {
  width: 22px;
  height: 32px;
  background-size: cover;
}

.prev-button {
  background-image: url("../../../../../assets/images/prev.png");
}

.next-button {
  background-image: url("../../../../../assets/images/next.png");
}

.disabled-button {
  opacity: 0.2;
}

.divider {
  width: 100%;
  height: 1px;
  background: #fabf8b;
  opacity: 0.3;
}

.match {
  display: flex;
  justify-content: space-evenly;
  /*width: 680px;*/
  /*width: 688px;*/
  height: 100px;
}

.match + .divider {
  background: #956840;
  opacity: 1;
}

.match-date {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 150px;
}

.time {
  width: 120px;
  /*height: 29px;*/
  font-size: 36px;
  font-weight: bold;
  color: #fabf8b;
}

.date {
  width: 102px;
  /*height: 16px;*/
  font-size: 20px;
  font-weight: 400;
}

.divider-column {
  width: 1px;
  height: 70px;
  margin-top: 15px;
  background: #956840;
}

.team-info {
  display: flex;
  /*justify-content: space-evenly;*/
  align-items: center;
  width: 540px;
  /*margin-left: 20px;*/
}

.team-name {
  width: 180px;
  font-size: 24px;
  font-weight: bold;
}

.team-icon {
  width: 45px;
  height: 45px;
  margin: 0px 10px;
}

.team-score {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  height: 48px;
  margin: 0 20px;
}

.win-count {
  width: 30px;
  height: 36px;
  line-height: 36px;
  font-size: 20px;
  font-weight: bold;
  background: rgba(251, 118, 46, 0.1);
}

.win {
  color: #fabf8b;
}

.colon {
  width: 12px;
  height: 36px;
  line-height: 36px;
  font-size: 24px;
  font-weight: bold;
}

.match-info {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  width: 80px;
  height: 100%;
  margin-right: 5px;
}

.match-info div {
  position: relative;
  width: 66px;
  height: 30px;
  line-height: 30px;
  background: rgba(251, 118, 46, 0.05);
  border: 1px solid #fabf8b;
}

.match-info div::before {
  content: "";
  background-image: url("../../../../../assets/images/triangle-white.svg");
  position: absolute;
  left: 2px;
  top: 2px;
  width: 6px;
  height: 6px;
  z-index: 8;
}

</style>



// WEBPACK FOOTER //
// src/components/iframe/matchSchedule/common/RegularSeason/Schedule.vue